export const  getFillAnalysesData = state => state.fillAnalyses.all;
export const getFillAnalysisData = state => state.fillAnalyses.fillAnalysis;
export const fillAnalysesIsFetching = state => state.fillAnalyses.loading.all;
export const fillAnalysisIsFetching = state => state.fillAnalyses.loading.fillAnalysis;